// extracted by mini-css-extract-plugin
module.exports = {"UserPanelContainer":"UserPanel_UserPanelContainer__3avUg","Icon":"UserPanel_Icon__eamAC","IconContainer":"UserPanel_IconContainer__3EhX4","Hide":"UserPanel_Hide__3H9qb"};